import api from './api';

export interface ActivityLogEntry {
  id: string;
  userId: string | null;
  action: string;
  resource: string;
  resourceId: string | null;
  summary: string | null;
  createdAt: string;
  user?: {
    id: string;
    fullName: string;
    email?: string | null;
    empNo?: string;
  } | null;
}

export const activityLogsService = {
  async getAll(): Promise<ActivityLogEntry[]> {
    const res = await api.get<ActivityLogEntry[]>('/activity-logs');
    return res.data;
  },
};
